module.exports = __webpack_public_path__ + "static/img/ad7-1.8815dc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark40/ad7-1.png
// module id = d+pA
// module chunks = 12